/*
 * @Author: Tahiti
 * @Date: 2025-10-23 18:06:29
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-12-28 15:02:19
 * @Description:
 * @FilePath: /weryai-web/locales/modules/common.ts
 */
export default {
    zh: {
        common: {
            tip: '提示',
            pleaseInputPrompt: '请输入提示词',
            pleaseInputImage: '请上传图片',
            download: '下载',
            cancel: '取消',
            confirm: '确认',
            loading: '加载中...',
            loadMore: '加载更多',
            noMore: '没有更多了',
            oneTaskRunning: '正在生成中，请稍等',
            maxImageSize: '图片大小不能超过 {maxSize} MB',
            onlineSearch: '联网搜索',
            searchFrom: '是否开启 Google 搜索',
            operationFailed: '操作失败',
            loadFailed: '加载失败',
            requestTimeout: '请求超时，请稍后重试',
            pageNotFoundTitle: 'AI 迷路了',
            pageNotFoundDesc:
                '这个页面可能被 AI 模型训练时遗漏了，或者它正在生成中... 不如看看我们的热门 AI 模型，探索更多精彩的创作可能！',
            unexpectedErrorTitle: 'AI 出了点小状况',
            unexpectedErrorDesc:
                '页面加载时遇到了意外。可能是 AI 正在思考，或者网络需要休息一下。你可以先返回首页，稍后再来试试。',
            goHome: '回到首页',
            goBack: '返回上一页',
            errorTip: '如果这个问题持续出现，请截图并联系支持人员。',
            errorDebug: '调试信息（仅开发环境显示）',
            reupload: '重新上传',
            supportTypes: '支持JPG、PNG、WEBP格式',
            aiReversalTitle: 'AI反推提示词',
            aiReversalShort: 'AI反推',
            use: '使用',
            startReversal: '开始反推',
            popularAIModels: '热门 AI 模型',
            previous: '上一个',
            next: '下一个',
            videoCarousel: '视频轮播',
            goToSlide: '跳转到第 {number} 张幻灯片',
            analyzing: '正在分析...',
            loginToGetFree: '登录即可免费创作',
            tryNow: '立即体验',
            model_online: `{model} 正式上线`,
            three_step: '简单三步，开始创作',
            close: '关闭',
            copy: '复制',
            like: '点赞',
            unlike: '取消点赞',
            play: '播放',
            pause: '暂停',
            backward: '后退',
            forward: '前进',
            high_level_tip: '这是一项高级功能，欢迎升级套餐使用此功能！',
            suggest_tip: '当前套餐不支持此功能，建议您先升级套餐！',
            communityWorksTitle: '社区精选作品',
            communityWorksSubtitle: '由 AI 模型生成的精彩作品',
            createSimilar: '创作同款',
            inspirationRecommend: '灵感推荐',
            viewMoreWorks: '查看社区1000+作品',
            textToVideo: '文生视频',
            imageToVideo: '图生视频',
            imageToImage: '图生图',
        },
    },
    en: {
        common: {
            tip: 'Tip',
            pleaseInputPrompt: 'Please input prompt',
            pleaseInputImage: 'Please upload image',
            download: 'Download',
            cancel: 'Cancel',
            confirm: 'Confirm',
            loading: 'Loading...',
            loadMore: 'Load more',
            noMore: 'No more',
            oneTaskRunning: 'Please wait while generating',
            maxImageSize: 'Image size cannot exceed {maxSize} MB',
            onlineSearch: 'Online Search',
            searchFrom: 'Whether to enable Google search',
            operationFailed: 'Operation failed',
            loadFailed: 'Load failed',
            requestTimeout: 'Request timeout, please try again later',
            pageNotFoundTitle: 'AI Got Lost',
            pageNotFoundDesc:
                "This page might have been missed during AI model training, or it's still being generated... Why not check out our popular AI models and explore more exciting creative possibilities!",
            unexpectedErrorTitle: 'AI Hit a Snag',
            unexpectedErrorDesc:
                'Something unexpected happened while loading. The AI might be thinking, or the network needs a break. You can return to the homepage and try again later.',
            goHome: 'Go to Home',
            goBack: 'Go Back',
            errorTip:
                'If this keeps happening, please take a screenshot and contact support.',
            errorDebug: 'Debug info (dev only)',
            reupload: 'Reupload',
            supportTypes: 'Supports JPG, PNG, WEBP formats',
            aiReversalTitle: 'AI Prompt Reverse',
            aiReversalShort: 'AI Reverse',
            use: 'Use',
            startReversal: 'Start Reverse',
            popularAIModels: 'Popular AI Models',
            previous: 'Previous',
            next: 'Next',
            videoCarousel: 'Video Carousel',
            goToSlide: 'Go to slide {number}',
            analyzing: 'Analyzing...',
            loginToGetFree: 'Log in to Create for Free',
            tryNow: 'Try Now',
            model_online: `{model} is now live`,
            three_step: '3 easy steps to start creating',
            close: 'Close',
            copy: 'Copy',
            like: 'Like',
            unlike: 'Unlike',
            play: 'Play',
            pause: 'Pause',
            backward: 'Backward',
            forward: 'Forward',
            high_level_tip:
                'This is an advanced feature. Upgrade your plan to use it!',
            suggest_tip:
                'Your current plan does not support this feature. Please upgrade your plan first!',
            communityWorksTitle: 'Community Featured Works',
            communityWorksSubtitle: 'Stunning creations generated by AI models',
            createSimilar: 'Create Similar',
            inspirationRecommend: 'Inspiration Recommend',
            viewMoreWorks: 'View 1000+ Community Works',
            textToVideo: 'Text to Video',
            imageToVideo: 'Image to Video',
            imageToImage: 'Image to Image',
        },
    },
    ja: {
        common: {
            tip: 'ヒント',
            pleaseInputPrompt: 'プロンプトを入力してください',
            pleaseInputImage: '画像をアップロードしてください',
            download: 'ダウンロード',
            cancel: 'キャンセル',
            confirm: '確認',
            loading: '読み込み中…',
            loadMore: 'もっと読み込む',
            noMore: 'これ以上ありません',
            oneTaskRunning: '生成中です。しばらくお待ちください',
            maxImageSize: '画像サイズは {maxSize} MB を超えることはできません',
            onlineSearch: 'オンライン検索',
            searchFrom: 'Google 検索を有効にするかどうか',
            operationFailed: '操作に失敗しました',
            loadFailed: '読み込みに失敗しました',
            requestTimeout:
                'リクエストがタイムアウトしました。後でもう一度お試しください',
            pageNotFoundTitle: 'AIが迷子になりました',
            pageNotFoundDesc:
                'このページはAIモデルの学習で見落とされたか、まだ生成中かもしれません… 人気のAIモデルをチェックして、もっとワクワクする創作の可能性を探してみましょう！',
            unexpectedErrorTitle: 'AIが少し問題に遭遇しました',
            unexpectedErrorDesc:
                'ページの読み込み中に予期しないエラーが発生しました。AIが考えているか、ネットワークが休憩が必要かもしれません。ホームページに戻って、後でもう一度お試しください。',
            goHome: 'ホームに戻る',
            goBack: '戻る',
            reupload: '再アップロード',
            supportTypes: 'JPG、PNG、WEBP形式をサポート',
            aiReversalTitle: 'AIプロンプト逆解析',
            aiReversalShort: 'AI逆解析',
            use: '使用',
            startReversal: '逆解析を開始',
            popularAIModels: '人気のAIモデル',
            previous: '前へ',
            next: '次へ',
            videoCarousel: 'ビデオカルーセル',
            goToSlide: 'スライド {number} に移動',
            analyzing: '解析中...',
            loginToGetFree: 'ログインして無料で作成',
            tryNow: '今すぐ試す',
            model_online: `{model} が正式リリース`,
            three_step: '簡単3ステップで創作を開始',
            close: '閉じる',
            copy: 'コピー',
            like: 'いいね',
            unlike: 'いいね解除',
            play: '再生',
            pause: '一時停止',
            high_level_tip:
                'これは高度な機能です。プランをアップグレードしてご利用ください！',
            suggest_tip:
                '現在のプランではこの機能をご利用いただけません。先にプランをアップグレードしてください！',
            errorTip: 'エラーヒント',
            errorDebug: 'デバッグ情報',
            backward: '戻る',
            forward: '次へ',
            communityWorksTitle: 'コミュニティ人気作品',
            communityWorksSubtitle: 'AIモデルが生成した素晴らしい作品',
            createSimilar: '同じものを作成',
            inspirationRecommend: 'インスピレーション推奨',
            viewMoreWorks: 'コミュニティ1000+作品を見る',
            textToVideo: 'テキストから動画',
            imageToVideo: '画像から動画',
            imageToImage: '画像から画像',
        },
    },
    ko: {
        common: {
            tip: '팁',
            pleaseInputPrompt: '프롬프트를 입력하세요',
            pleaseInputImage: '이미지를 업로드하세요',
            download: '다운로드',
            cancel: '취소',
            confirm: '확인',
            loading: '로딩 중...',
            loadMore: '더 보기',
            noMore: '더 이상 없습니다',
            oneTaskRunning: '생성 중입니다. 잠시 후 다시 시도해주세요',
            maxImageSize: '이미지 크기는 {maxSize} MB를 초과할 수 없습니다',
            onlineSearch: '온라인 검색',
            searchFrom: 'Google 검색을 활성화하시겠습니까',
            operationFailed: '작업 실패',
            loadFailed: '로드 실패',
            requestTimeout: '요청 시간 초과, 나중에 다시 시도하세요',
            pageNotFoundTitle: 'AI가 길을 잃었습니다',
            pageNotFoundDesc:
                '이 페이지는 AI 모델 학습 과정에서 누락되었거나 아직 생성 중일 수 있어요... 인기 AI 모델을 확인하고 더 멋진 창작 가능성을 탐색해 보세요!',
            unexpectedErrorTitle: 'AI가 작은 문제를 만났습니다',
            unexpectedErrorDesc:
                '페이지 로드 중 예상치 못한 오류가 발생했습니다. AI가 생각 중이거나 네트워크가 휴식이 필요할 수 있습니다. 홈페이지로 돌아가서 나중에 다시 시도해 주세요.',
            goHome: '홈으로 이동',
            goBack: '뒤로 가기',
            reupload: '다시 업로드',
            supportTypes: 'JPG, PNG, WEBP 형식 지원',
            aiReversalTitle: 'AI 프롬프트 역추적',
            aiReversalShort: 'AI 역추적',
            use: '사용',
            startReversal: '역추적 시작',
            popularAIModels: '인기 AI 모델',
            previous: '이전',
            next: '다음',
            videoCarousel: '비디오 캐러셀',
            goToSlide: '슬라이드 {number}로 이동',
            analyzing: '분석 중...',
            loginToGetFree: '로그인하여 무료로 생성',
            tryNow: '지금 시도',
            model_online: `{model} 정식 출시`,
            three_step: '간단한 3단계로 제작 시작',
            close: '닫기',
            copy: '복사',
            like: '좋아요',
            unlike: '좋아요 취소',
            play: '재생',
            pause: '일시정지',
            high_level_tip:
                '고급 기능입니다. 플랜을 업그레이드하여 이용해 주세요!',
            suggest_tip:
                '현재 요금제에서는 이 기능을 지원하지 않습니다. 먼저 요금제를 업그레이드해 주세요!',
            errorTip: '오류 팁',
            errorDebug: '디버그 정보',
            backward: '뒤로',
            forward: '앞으로',
            communityWorksTitle: '커뮤니티 인기 작품',
            communityWorksSubtitle: 'AI 모델이 생성한 멋진 작품',
            createSimilar: '유사한 작품 만들기',
            inspirationRecommend: '영감 추천',
            viewMoreWorks: '커뮤니티 1000+ 작품 보기',
            textToVideo: '텍스트를 비디오로',
            imageToVideo: '이미지를 비디오로',
            imageToImage: '이미지를 이미지로',
        },
    },
    tw: {
        common: {
            tip: '提示',
            pleaseInputPrompt: '請輸入提示詞',
            pleaseInputImage: '請上傳圖片',
            download: '下載',
            cancel: '取消',
            confirm: '確認',
            loading: '載入中...',
            loadMore: '載入更多',
            noMore: '沒有更多了',
            oneTaskRunning: '正在生成中，請稍等',
            maxImageSize: '圖片大小不能超過 {maxSize} MB',
            onlineSearch: '連網搜尋',
            searchFrom: '是否開啟 Google 搜尋',
            operationFailed: '操作失敗',
            loadFailed: '載入失敗',
            requestTimeout: '請求逾時，請稍後再試',
            pageNotFoundTitle: 'AI 迷路了',
            pageNotFoundDesc:
                '這個頁面可能被 AI 模型訓練時遺漏了，或正在生成中... 不如看看我們的熱門 AI 模型，探索更多精彩的創作可能！',
            unexpectedErrorTitle: 'AI 出了點小狀況',
            unexpectedErrorDesc:
                '頁面載入時遇到意外。可能是 AI 正在思考，或網路需要休息一下。你可以先回到首頁，稍後再試。',
            goHome: '回到首頁',
            goBack: '返回上一頁',
            errorTip: '如果問題持續出現，請截圖並聯絡支援人員。',
            errorDebug: '除錯資訊（僅開發環境顯示）',
            reupload: '重新上傳',
            supportTypes: '支援 JPG、PNG、WEBP 格式',
            aiReversalTitle: 'AI 反推提示詞',
            aiReversalShort: 'AI 反推',
            use: '使用',
            startReversal: '開始反推',
            popularAIModels: '熱門 AI 模型',
            previous: '上一個',
            next: '下一個',
            videoCarousel: '影片輪播',
            goToSlide: '跳轉到第 {number} 張幻燈片',
            analyzing: '正在分析...',
            loginToGetFree: '登入即可免費創作',
            tryNow: '立即體驗',
            model_online: `{model} 正式上線`,
            three_step: '簡單三步，開始創作',
            close: '關閉',
            copy: '複製',
            like: '點讚',
            unlike: '取消點讚',
            play: '播放',
            pause: '暫停',
            backward: '後退',
            forward: '前進',
            high_level_tip: '這是進階功能，歡迎升級方案使用此功能！',
            suggest_tip: '目前方案不支援此功能，建議先升級方案！',
            communityWorksTitle: '社群精選作品',
            communityWorksSubtitle: '由 AI 模型生成的精彩作品',
            createSimilar: '創作同款',
            inspirationRecommend: '靈感推薦',
            viewMoreWorks: '查看社群1000+作品',
            textToVideo: '文生影片',
            imageToVideo: '圖生影片',
            imageToImage: '圖生圖',
        },
    },
    pl: {
        common: {
            tip: 'Wskazówka',
            pleaseInputPrompt: 'Wpisz prompt',
            pleaseInputImage: 'Prześlij obraz',
            download: 'Pobierz',
            cancel: 'Anuluj',
            confirm: 'Potwierdź',
            loading: 'Ładowanie...',
            loadMore: 'Załaduj więcej',
            noMore: 'Brak więcej',
            oneTaskRunning: 'Trwa generowanie, proszę czekać',
            maxImageSize: 'Rozmiar obrazu nie może przekroczyć {maxSize} MB',
            onlineSearch: 'Wyszukiwanie online',
            searchFrom: 'Czy włączyć wyszukiwanie Google',
            operationFailed: 'Operacja nieudana',
            loadFailed: 'Nie udało się załadować',
            requestTimeout: 'Przekroczono czas żądania, spróbuj ponownie później',
            pageNotFoundTitle: 'AI się zgubiła',
            pageNotFoundDesc:
                'Ta strona mogła zostać pominięta podczas treningu modeli AI albo jest jeszcze generowana... Sprawdź nasze popularne modele AI i odkryj więcej inspiracji!',
            unexpectedErrorTitle: 'AI napotkała problem',
            unexpectedErrorDesc:
                'Podczas ładowania wystąpił nieoczekiwany błąd. AI może „myśleć”, albo sieć potrzebuje chwili przerwy. Wróć na stronę główną i spróbuj później.',
            goHome: 'Wróć na stronę główną',
            goBack: 'Wróć',
            errorTip:
                'Jeśli problem się powtarza, zrób zrzut ekranu i skontaktuj się z pomocą.',
            errorDebug: 'Informacje debugowania (tylko dev)',
            reupload: 'Prześlij ponownie',
            supportTypes: 'Obsługiwane formaty JPG, PNG, WEBP',
            aiReversalTitle: 'AI – odwrócenie promptu',
            aiReversalShort: 'AI Reverse',
            use: 'Użyj',
            startReversal: 'Rozpocznij odwracanie',
            popularAIModels: 'Popularne modele AI',
            previous: 'Poprzedni',
            next: 'Następny',
            videoCarousel: 'Karuzela wideo',
            goToSlide: 'Przejdź do slajdu {number}',
            analyzing: 'Analiza...',
            loginToGetFree: 'Zaloguj się, aby tworzyć za darmo',
            tryNow: 'Wypróbuj teraz',
            model_online: `{model} już dostępny`,
            three_step: 'Trzy proste kroki, aby zacząć tworzyć',
            close: 'Zamknij',
            copy: 'Kopiuj',
            like: 'Lubię to',
            unlike: 'Cofnij polubienie',
            play: 'Odtwarzaj',
            pause: 'Wstrzymaj',
            backward: 'Cofnij',
            forward: 'Przewiń',
            high_level_tip:
                'To funkcja zaawansowana. Zaktualizuj plan, aby z niej skorzystać!',
            suggest_tip:
                'Obecny plan nie obsługuje tej funkcji. Najpierw zaktualizuj plan.',
            communityWorksTitle: 'Wyróżnione prace społeczności',
            communityWorksSubtitle: 'Wspaniałe kreacje wygenerowane przez modele AI',
            createSimilar: 'Utwórz podobne',
            inspirationRecommend: 'Polecane inspiracje',
            viewMoreWorks: 'Zobacz 1000+ prac społeczności',
            textToVideo: 'Tekst na wideo',
            imageToVideo: 'Obraz na wideo',
            imageToImage: 'Obraz na obraz',
        },
    },
    es: {
        common: {
            tip: 'Consejo',
            pleaseInputPrompt: 'Por favor ingrese el prompt',
            pleaseInputImage: 'Por favor suba una imagen',
            download: 'Descargar',
            cancel: 'Cancelar',
            confirm: 'Confirmar',
            loading: 'Cargando...',
            loadMore: 'Cargar más',
            noMore: 'No hay más',
            oneTaskRunning: 'Por favor, espere mientras se genera',
            maxImageSize:
                'El tamaño de la imagen no puede exceder los {maxSize} MB',
            onlineSearch: 'Búsqueda en línea',
            searchFrom: '¿Desea activar la búsqueda en Google?',
            operationFailed: 'Operación fallida',
            loadFailed: 'Carga fallida',
            requestTimeout:
                'Tiempo de espera de solicitud, intente de nuevo más tarde',
            pageNotFoundTitle: 'La IA se perdió',
            pageNotFoundDesc:
                'Es posible que esta página se haya pasado por alto durante el entrenamiento del modelo de IA, o que aún se esté generando... ¿Por qué no echas un vistazo a nuestros modelos de IA populares y exploras más posibilidades creativas increíbles?',
            unexpectedErrorTitle: 'La IA encontró un problema',
            unexpectedErrorDesc:
                'Algo inesperado ocurrió al cargar la página. La IA podría estar pensando, o la red necesita un descanso. Puedes volver a la página de inicio e intentarlo más tarde.',
            goHome: 'Ir al inicio',
            goBack: 'Regresar',
            reupload: 'Reupload',
            supportTypes: 'Supports JPG, PNG, WEBP formats',
            aiReversalTitle: 'Inversión de prompt con IA',
            aiReversalShort: 'IA inversa',
            use: 'Usar',
            startReversal: 'Iniciar inversión',
            popularAIModels: 'Modelos de IA populares',
            previous: 'Anterior',
            next: 'Siguiente',
            videoCarousel: 'Carrusel de video',
            goToSlide: 'Ir a la diapositiva {number}',
            analyzing: 'Analizando...',
            loginToGetFree: 'Inicia sesión para crear gratis',
            tryNow: 'Prueba ahora',
            model_online: `{model} lanzado oficialmente`,
            three_step: '3 pasos sencillos para empezar a crear',
            close: 'Cerrar',
            copy: 'Copiar',
            like: 'Me gusta',
            unlike: 'Ya no me gusta',
            play: 'Reproducir',
            pause: 'Pausar',
            high_level_tip:
                'Esta es una función avanzada. ¡Actualiza tu plan para usarla!',
            suggest_tip:
                'Tu plan actual no admite esta función. ¡Te recomendamos actualizar tu plan primero!',
            errorTip: 'Sugerencia de error',
            errorDebug: 'Información de depuración',
            backward: 'Atrás',
            forward: 'Adelante',
            communityWorksTitle: 'Obras destacadas de la comunidad',
            communityWorksSubtitle: 'Creaciones increíbles generadas por modelos de IA',
            createSimilar: 'Crear similar',
            inspirationRecommend: 'Inspiración recomendada',
            viewMoreWorks: 'Ver 1000+ obras de la comunidad',
            textToVideo: 'Texto a video',
            imageToVideo: 'Imagen a video',
            imageToImage: 'Imagen a imagen',
        },
    },
    fr: {
        common: {
            tip: 'Astuce',
            pleaseInputPrompt: 'Veuillez saisir le prompt',
            pleaseInputImage: 'Veuillez télécharger une image',
            download: 'Télécharger',
            cancel: 'Annuler',
            confirm: 'Confirmer',
            loading: 'Chargement...',
            loadMore: 'Charger plus',
            noMore: 'Plus de contenu',
            oneTaskRunning: 'Veuillez patienter pendant la génération',
            maxImageSize:
                "La taille de l'image ne peut pas dépasser {maxSize} MB",
            onlineSearch: 'Recherche en ligne',
            searchFrom: 'Voulez-vous activer la recherche Google ?',
            operationFailed: 'Opération échouée',
            loadFailed: 'Échec du chargement',
            requestTimeout:
                'Délai de demande expiré, veuillez réessayer plus tard',
            pageNotFoundTitle: "L'IA s'est perdue",
            pageNotFoundDesc:
                'Cette page a peut-être été oubliée lors de l’entraînement du modèle d’IA, ou elle est peut-être encore en cours de génération... Pourquoi ne pas découvrir nos modèles d’IA populaires et explorer encore plus de possibilités créatives ?',
            unexpectedErrorTitle: "L'IA a rencontré un problème",
            unexpectedErrorDesc:
                "Quelque chose d'inattendu s'est produit lors du chargement. L'IA réfléchit peut-être, ou le réseau a besoin d'une pause. Vous pouvez retourner à la page d'accueil et réessayer plus tard.",
            goHome: "Aller à l'accueil",
            goBack: 'Retourner',
            reupload: 'Recharger',
            supportTypes: 'Supports JPG, PNG, WEBP formats',
            aiReversalTitle: 'Rétro-ingénierie de prompt IA',
            aiReversalShort: 'IA rétro',
            use: 'Utiliser',
            startReversal: 'Démarrer',
            popularAIModels: 'Modèles IA populaires',
            previous: 'Précédent',
            next: 'Suivant',
            videoCarousel: 'Carrousel vidéo',
            goToSlide: 'Aller à la diapositive {number}',
            analyzing: 'Analyse en cours...',
            loginToGetFree: 'Connectez-vous pour créer gratuitement',
            tryNow: 'Essayer maintenant',
            model_online: `{model} est officiellement lancé`,
            three_step: '3 étapes simples pour commencer à créer',
            close: 'Fermer',
            copy: 'Copier',
            like: "J'aime",
            unlike: "Je n'aime plus",
            play: 'Lire',
            pause: 'Pause',
            high_level_tip:
                "C'est une fonctionnalité avancée. Passez à une offre supérieure pour l'utiliser !",
            suggest_tip:
                'Votre offre actuelle ne prend pas en charge cette fonctionnalité. Nous vous conseillons d’upgrader votre offre d’abord !',
            errorTip: 'Conseil d\'erreur',
            errorDebug: 'Informations de débogage',
            backward: 'Retour',
            forward: 'Suivant',
            communityWorksTitle: 'Œuvres vedettes de la communauté',
            communityWorksSubtitle: 'Créations époustouflantes générées par des modèles IA',
            createSimilar: 'Créer similaire',
            inspirationRecommend: 'Inspiration recommandée',
            viewMoreWorks: 'Voir 1000+ œuvres de la communauté',
            textToVideo: 'Texte en vidéo',
            imageToVideo: 'Image en vidéo',
            imageToImage: 'Image en image',
        },
    },
    de: {
        common: {
            tip: 'Tipp',
            pleaseInputPrompt: 'Bitte geben Sie einen Prompt ein',
            pleaseInputImage: 'Bitte laden Sie ein Bild hoch',
            download: 'Herunterladen',
            cancel: 'Abbrechen',
            confirm: 'Bestätigen',
            loading: 'Lädt...',
            loadMore: 'Mehr laden',
            noMore: 'Keine weiteren Inhalte',
            oneTaskRunning: 'Bitte warten Sie, während die Generierung erfolgt',
            maxImageSize: 'Die Bildgröße darf {maxSize} MB nicht überschreiten',
            onlineSearch: 'Online-Suche',
            searchFrom: 'Möchten Sie die Online-Suche aktivieren?',
            operationFailed: 'Vorgang fehlgeschlagen',
            loadFailed: 'Laden fehlgeschlagen',
            requestTimeout:
                'Zeitüberschreitung der Anfrage, bitte versuchen Sie es später erneut',
            pageNotFoundTitle: 'Die KI hat sich verlaufen',
            pageNotFoundDesc:
                'Diese Seite wurde möglicherweise beim Training des KI-Modells übersehen oder wird noch generiert... Schau dir doch unsere beliebten KI-Modelle an und entdecke noch mehr kreative Möglichkeiten!',
            unexpectedErrorTitle: 'Die KI ist auf ein Problem gestoßen',
            unexpectedErrorDesc:
                'Beim Laden ist etwas Unerwartetes passiert. Die KI denkt vielleicht nach oder das Netzwerk braucht eine Pause. Sie können zur Startseite zurückkehren und es später erneut versuchen.',
            goHome: 'Zur Startseite',
            goBack: 'Zurück',
            reupload: 'Erneut hochladen',
            supportTypes: 'Supports JPG, PNG, WEBP formats',
            aiReversalTitle: 'KI-Prompt-Rückwärtsanalyse',
            aiReversalShort: 'KI-Rückwärts',
            use: 'Verwenden',
            startReversal: 'Rückwärtsanalyse starten',
            popularAIModels: 'Beliebte KI-Modelle',
            previous: 'Vorherige',
            next: 'Nächste',
            videoCarousel: 'Video-Karussell',
            goToSlide: 'Zur Folie {number} wechseln',
            analyzing: 'Analysiere...',
            loginToGetFree: 'Melden Sie sich an, um kostenlos zu erstellen',
            tryNow: 'Jetzt ausprobieren',
            model_online: `{model} ist offiziell live`,
            three_step: 'In 3 einfachen Schritten loslegen',
            close: 'Schließen',
            copy: 'Kopieren',
            like: 'Gefällt mir',
            unlike: 'Gefällt mir nicht mehr',
            play: 'Abspielen',
            pause: 'Pausieren',
            high_level_tip:
                'Dies ist eine erweiterte Funktion. Upgrade dein Paket, um sie zu nutzen!',
            suggest_tip:
                'Dein aktuelles Paket unterstützt diese Funktion nicht. Bitte upgrade zuerst dein Paket!',
            errorTip: 'Fehlerhinweis',
            errorDebug: 'Debug-Informationen',
            backward: 'Zurück',
            forward: 'Vorwärts',
            communityWorksTitle: 'Community-Highlights',
            communityWorksSubtitle: 'Atemberaubende Kreationen von KI-Modellen',
            createSimilar: 'Ähnliches erstellen',
            inspirationRecommend: 'Empfohlene Inspiration',
            viewMoreWorks: '1000+ Community-Werke ansehen',
            textToVideo: 'Text zu Video',
            imageToVideo: 'Bild zu Video',
            imageToImage: 'Bild zu Bild',
        },
    },
    ru: {
        common: {
            tip: 'Подсказка',
            pleaseInputPrompt: 'Пожалуйста, введите подсказку',
            pleaseInputImage: 'Пожалуйста, загрузите изображение',
            download: 'Скачать',
            cancel: 'Отмена',
            confirm: 'Подтвердить',
            loading: 'Загрузка...',
            loadMore: 'Загрузить еще',
            noMore: 'Больше нет данных',
            oneTaskRunning: 'Пожалуйста, подождите, пока генерация завершена',
            maxImageSize: 'Размер изображения не может превышать {maxSize} MB',
            onlineSearch: 'Поиск в Интернете',
            searchFrom: 'Хотите ли вы включить поиск в Google?',
            operationFailed: 'Операция не удалась',
            loadFailed: 'Не удалось загрузить',
            requestTimeout:
                'Время ожидания запроса истекло, повторите попытку позже',
            pageNotFoundTitle: 'ИИ заблудился',
            pageNotFoundDesc:
                'Эта страница могла быть пропущена во время обучения модели ИИ или всё ещё находится в процессе генерации... Почему бы не посмотреть наши популярные модели ИИ и не открыть для себя ещё больше творческих возможностей!',
            unexpectedErrorTitle: 'ИИ столкнулся с проблемой',
            unexpectedErrorDesc:
                'При загрузке произошло что-то неожиданное. ИИ, возможно, размышляет, или сети нужен перерыв. Вы можете вернуться на главную страницу и попробовать позже.',
            goHome: 'На главную',
            goBack: 'Назад',
            reupload: 'Загрузить заново',
            supportTypes: 'Supports JPG, PNG, WEBP formats',
            aiReversalTitle: 'AI обратный промпт',
            aiReversalShort: 'AI обратный',
            use: 'Использовать',
            startReversal: 'Начать',
            popularAIModels: 'Популярные модели ИИ',
            previous: 'Предыдущий',
            next: 'Следующий',
            videoCarousel: 'Видео карусель',
            goToSlide: 'Перейти к слайду {number}',
            analyzing: 'Анализ...',
            loginToGetFree: 'Войдите, чтобы создавать бесплатно',
            tryNow: 'Попробовать сейчас',
            model_online: `{model} официально запущен`,
            three_step: '3 простых шага, чтобы начать творить',
            close: 'Закрыть',
            copy: 'Копировать',
            like: 'Нравится',
            unlike: 'Больше не нравится',
            play: 'Воспроизвести',
            pause: 'Пауза',
            high_level_tip:
                'Это расширенная функция. Обновите тариф, чтобы воспользоваться ею!',
            suggest_tip:
                'Ваш текущий тариф не поддерживает эту функцию. Рекомендуем сначала обновить тариф!',
            errorTip: 'Подсказка об ошибке',
            errorDebug: 'Отладочная информация',
            communityWorksTitle: 'Избранные работы сообщества',
            communityWorksSubtitle: 'Потрясающие творения, созданные моделями ИИ',
            createSimilar: 'Создать похожее',
            inspirationRecommend: 'Рекомендуемое вдохновение',
            viewMoreWorks: 'Посмотреть 1000+ работ сообщества',
            textToVideo: 'Текст в видео',
            imageToVideo: 'Изображение в видео',
            imageToImage: 'Изображение в изображение',
            backward: 'Назад',
            forward: 'Вперед',
        },
    },
    pt: {
        common: {
            tip: 'Dica',
            pleaseInputPrompt: 'Por favor, insira o prompt',
            pleaseInputImage: 'Por favor, faça upload de uma imagem',
            download: 'Baixar',
            cancel: 'Cancelar',
            confirm: 'Confirmar',
            loading: 'Carregando...',
            loadMore: 'Carregar mais',
            noMore: 'Não há mais',
            oneTaskRunning:
                'Por favor, aguarde enquanto a geração está em andamento',
            maxImageSize: 'O tamanho da imagem não pode exceder {maxSize} MB',
            onlineSearch: 'Busca na Internet',
            searchFrom: 'Deseja ativar a busca na Google?',
            operationFailed: 'Operação falhou',
            loadFailed: 'Falha ao carregar',
            requestTimeout:
                'Tempo limite da solicitação, tente novamente mais tarde',
            pageNotFoundTitle: 'A IA se perdeu',
            pageNotFoundDesc:
                'Esta página pode ter sido esquecida durante o treinamento do modelo de IA, ou ainda está sendo gerada... Que tal conferir nossos modelos de IA populares e explorar ainda mais possibilidades criativas incríveis?',
            unexpectedErrorTitle: 'A IA encontrou um problema',
            unexpectedErrorDesc:
                'Algo inesperado aconteceu ao carregar. A IA pode estar pensando, ou a rede precisa de uma pausa. Você pode voltar à página inicial e tentar novamente mais tarde.',
            goHome: 'Ir para o início',
            goBack: 'Voltar',
            reupload: 'Reupload',
            supportTypes: 'Supports JPG, PNG, WEBP formats',
            aiReversalTitle: 'Reversão de prompt com IA',
            aiReversalShort: 'IA reversa',
            use: 'Usar',
            startReversal: 'Iniciar reversão',
            popularAIModels: 'Modelos de IA populares',
            previous: 'Anterior',
            next: 'Próximo',
            videoCarousel: 'Carrossel de vídeo',
            goToSlide: 'Ir para o slide {number}',
            analyzing: 'Analisando...',
            loginToGetFree: 'Faça login para criar gratuitamente',
            tryNow: 'Experimentar agora',
            model_online: `{model} lançado oficialmente`,
            three_step: '3 passos simples para começar a criar',
            close: 'Fechar',
            copy: 'Copiar',
            like: 'Curtir',
            unlike: 'Descurtir',
            play: 'Reproduzir',
            pause: 'Pausar',
            high_level_tip:
                'Este é um recurso avançado. Faça upgrade do seu plano para usar este recurso!',
            suggest_tip:
                'Seu plano atual não oferece suporte a este recurso. Recomendamos fazer upgrade do seu plano primeiro!',
            errorTip: 'Dica de erro',
            errorDebug: 'Informações de depuração',
            backward: 'Voltar',
            forward: 'Avançar',
            communityWorksTitle: 'Obras em destaque da comunidade',
            communityWorksSubtitle: 'Criações incríveis geradas por modelos de IA',
            createSimilar: 'Criar similar',
            inspirationRecommend: 'Inspiração recomendada',
            viewMoreWorks: 'Ver 1000+ obras da comunidade',
            textToVideo: 'Texto para vídeo',
            imageToVideo: 'Imagem para vídeo',
            imageToImage: 'Imagem para imagem',
        },
    },
    it: {
        common: {
            tip: 'Suggerimento',
            pleaseInputPrompt: 'Si prega di inserire il prompt',
            pleaseInputImage: "Si prega di caricare un'immagine",
            download: 'Scarica',
            cancel: 'Annulla',
            confirm: 'Conferma',
            loading: 'Caricamento...',
            loadMore: 'Carica altro',
            noMore: 'Non c’è altro',
            oneTaskRunning:
                'Si prega di attendere mentre la generazione è in corso',
            maxImageSize:
                "La dimensione dell'immagine non può superare i {maxSize} MB",
            onlineSearch: 'Ricerca online',
            searchFrom: 'Vuoi attivare la ricerca in Google?',
            operationFailed: 'Operazione fallita',
            loadFailed: 'Caricamento fallito',
            requestTimeout: 'Timeout della richiesta, riprova più tardi',
            pageNotFoundTitle: "L'IA si è persa",
            pageNotFoundDesc:
                'Questa pagina potrebbe essere stata tralasciata durante l’addestramento del modello IA oppure è ancora in fase di generazione... Perché non dai un’occhiata ai nostri modelli IA più popolari ed esplori altre fantastiche possibilità creative?',
            unexpectedErrorTitle: "L'IA ha incontrato un problema",
            unexpectedErrorDesc:
                "Qualcosa di inaspettato è accaduto durante il caricamento. L'IA potrebbe star pensando, o la rete ha bisogno di una pausa. Puoi tornare alla home page e riprovare più tardi.",
            goHome: 'Vai alla Home',
            goBack: 'Indietro',
            reupload: 'Ricarica',
            supportTypes: 'Supports JPG, PNG, WEBP formats',
            aiReversalTitle: 'Reverse prompt con IA',
            aiReversalShort: 'IA reverse',
            use: 'Usa',
            startReversal: 'Avvia reverse',
            popularAIModels: 'Modelli IA popolari',
            previous: 'Precedente',
            next: 'Successivo',
            videoCarousel: 'Carosello video',
            goToSlide: 'Vai alla diapositiva {number}',
            analyzing: 'Analisi in corso...',
            loginToGetFree: 'Accedi per creare gratuitamente',
            tryNow: 'Prova ora',
            model_online: `{model} lanciato ufficialmente`,
            three_step: '3 semplici passaggi per iniziare a creare',
            close: 'Chiudi',
            copy: 'Copia',
            like: 'Mi piace',
            unlike: 'Non mi piace più',
            play: 'Riproduci',
            pause: 'Pausa',
            high_level_tip:
                'Questa è una funzione avanzata. Aggiorna il tuo piano per usarla!',
            suggest_tip:
                'Il tuo piano attuale non supporta questa funzione. Ti consigliamo di aggiornare il piano prima!',
            errorTip: 'Suggerimento errore',
            errorDebug: 'Informazioni di debug',
            backward: 'Indietro',
            forward: 'Avanti',
            communityWorksTitle: 'Opere in evidenza della comunità',
            communityWorksSubtitle: 'Creazioni straordinarie generate da modelli AI',
            createSimilar: 'Crea simile',
            inspirationRecommend: 'Ispirazione consigliata',
            viewMoreWorks: 'Vedi 1000+ opere della community',
            textToVideo: 'Testo a video',
            imageToVideo: 'Immagine a video',
            imageToImage: 'Immagine a immagine',
        },
    },
    ar: {
        common: {
            tip: 'نصيحة',
            pleaseInputPrompt: 'يرجى إدخال الموجه',
            pleaseInputImage: 'يرجى تحميل صورة',
            download: 'تحميل',
            cancel: 'إلغاء',
            confirm: 'تأكيد',
            loading: 'جارٍ التحميل...',
            loadMore: 'تحميل المزيد',
            noMore: 'لا مزيد من البيانات',
            oneTaskRunning: 'يرجى الإنتظار أثناء عملية التوليد',
            maxImageSize: 'حجم الصورة لا يمكن أن يتجاوز {maxSize} MB',
            onlineSearch: 'البحث على الإنترنت',
            searchFrom: 'هل تريد تمكين البحث في Google؟',
            operationFailed: 'فشلت العملية',
            loadFailed: 'فشل التحميل',
            requestTimeout: 'انتهت مهلة الطلب، يرجى المحاولة مرة أخرى لاحقًا',
            pageNotFoundTitle: 'الذكاء الاصطناعي ضاع',
            pageNotFoundDesc:
                'قد تكون هذه الصفحة قد تمّت مُغافلتها أثناء تدريب نموذج الذكاء الاصطناعي، أو أنها لا تزال قيد الإنشاء... لماذا لا تلقي نظرة على نماذج الذكاء الاصطناعي الشائعة لدينا وتستكشف المزيد من الإمكانات الإبداعية الرائعة؟',
            unexpectedErrorTitle: 'واجه الذكاء الاصطناعي مشكلة',
            unexpectedErrorDesc:
                'حدث شيء غير متوقع أثناء التحميل. قد يكون الذكاء الاصطناعي يفكر، أو أن الشبكة تحتاج إلى استراحة. يمكنك العودة إلى الصفحة الرئيسية والمحاولة مرة أخرى لاحقًا.',
            goHome: 'الذهاب للرئيسية',
            goBack: 'رجوع',
            reupload: 'إعادة التحميل',
            supportTypes: 'Supports JPG, PNG, WEBP formats',
            aiReversalTitle: 'عكس الموجه بالذكاء الاصطناعي',
            aiReversalShort: 'عكس الموجه',
            use: 'استخدام',
            startReversal: 'بدء العكس',
            popularAIModels: 'الأنماط الذكائية الشائعة',
            previous: 'السابق',
            next: 'التالي',
            videoCarousel: 'عرض الفيديو الدوار',
            goToSlide: 'انتقل إلى الشريحة {number}',
            analyzing: 'جارٍ التحليل...',
            loginToGetFree: 'سجّل الدخول للإنشاء مجانًا',
            tryNow: 'جرب الآن',
            model_online: `تم الإطلاق الرسمي لـ {model}`,
            three_step: '3 خطوات بسيطة لبدء الإبداع',
            close: 'إغلاق',
            copy: 'نسخ',
            like: 'إعجاب',
            unlike: 'إلغاء الإعجاب',
            play: 'تشغيل',
            pause: 'إيقاف مؤقت',
            high_level_tip:
                'هذه ميزة متقدمة. قم بترقية خطتك لاستخدام هذه الميزة!',
            suggest_tip:
                'خطتك الحالية لا تدعم هذه الميزة. ننصحك بترقية خطتك أولاً!',
            errorTip: 'تلميح الخطأ',
            errorDebug: 'معلومات التصحيح',
            backward: 'خلف',
            forward: 'أمام',
            communityWorksTitle: 'أعمال مميزة من المجتمع',
            communityWorksSubtitle: 'إبداعات مذهلة تم إنشاؤها بواسطة نماذج الذكاء الاصطناعي',
            createSimilar: 'إنشاء مماثل',
            inspirationRecommend: 'الإلهام الموصى به',
            viewMoreWorks: 'عرض أكثر من 1000 عمل من المجتمع',
            textToVideo: 'نص إلى فيديو',
            imageToVideo: 'صورة إلى فيديو',
            imageToImage: 'صورة إلى صورة',
        },
    },
    // 泰语
    th: {
        common: {
            tip: 'เคล็ดลับ',
            pleaseInputPrompt: 'กรุณาใส่คำสั่ง',
            pleaseInputImage: 'กรุณาอัปโหลดรูปภาพ',
            download: 'ดาวน์โหลด',
            cancel: 'ยกเลิก',
            confirm: 'ยืนยัน',
            loading: 'กำลังโหลด...',
            loadMore: 'โหลดเพิ่มเติม',
            noMore: 'ไม่มีข้อมูลเพิ่มเติม',
            oneTaskRunning: 'กรุณารอสักครู่ กำลังสร้าง',
            maxImageSize: 'ขนาดรูปภาพต้องไม่เกิน {maxSize} MB',
            onlineSearch: 'ค้นหาออนไลน์',
            searchFrom: 'เปิดใช้งานการค้นหา Google หรือไม่',
            operationFailed: 'การดำเนินการล้มเหลว',
            loadFailed: 'โหลดล้มเหลว',
            requestTimeout: 'หมดเวลาคำขอ กรุณาลองใหม่ภายหลัง',
            pageNotFoundTitle: 'AI หลงทาง',
            pageNotFoundDesc:
                'หน้านี้อาจถูกข้ามไปในการฝึกโมเดล AI หรือยังอยู่ระหว่างการสร้าง... ลองดูโมเดล AI ยอดนิยมของเราและสำรวจความเป็นไปได้ในการสร้างสรรค์ที่น่าตื่นเต้นมากขึ้น!',
            unexpectedErrorTitle: 'AI พบปัญหา',
            unexpectedErrorDesc:
                'เกิดข้อผิดพลาดขณะโหลด AI อาจกำลังคิด หรือเครือข่ายต้องการพัก คุณสามารถกลับไปหน้าแรกและลองใหม่ภายหลัง',
            goHome: 'กลับหน้าแรก',
            goBack: 'ย้อนกลับ',
            errorTip: 'หากปัญหายังคงเกิดขึ้น กรุณาถ่ายภาพหน้าจอและติดต่อฝ่ายสนับสนุน',
            errorDebug: 'ข้อมูลดีบัก (เฉพาะโหมดพัฒนา)',
            reupload: 'อัปโหลดใหม่',
            supportTypes: 'รองรับรูปแบบ JPG, PNG, WEBP',
            aiReversalTitle: 'AI ย้อนกลับคำสั่ง',
            aiReversalShort: 'AI ย้อนกลับ',
            use: 'ใช้งาน',
            startReversal: 'เริ่มย้อนกลับ',
            popularAIModels: 'โมเดล AI ยอดนิยม',
            previous: 'ก่อนหน้า',
            next: 'ถัดไป',
            videoCarousel: 'สไลด์วิดีโอ',
            goToSlide: 'ไปที่สไลด์ {number}',
            analyzing: 'กำลังวิเคราะห์...',
            loginToGetFree: 'เข้าสู่ระบบเพื่อสร้างฟรี',
            tryNow: 'ลองเลย',
            model_online: `{model} เปิดตัวอย่างเป็นทางการ`,
            three_step: '3 ขั้นตอนง่ายๆ เพื่อเริ่มสร้างสรรค์',
            close: 'ปิด',
            copy: 'คัดลอก',
            like: 'ถูกใจ',
            unlike: 'ยกเลิกถูกใจ',
            play: 'เล่น',
            pause: 'หยุดชั่วคราว',
            backward: 'ย้อนกลับ',
            forward: 'เดินหน้า',
            high_level_tip: 'นี่คือฟีเจอร์ขั้นสูง อัปเกรดแพ็กเกจเพื่อใช้งาน!',
            suggest_tip: 'แพ็กเกจปัจจุบันไม่รองรับฟีเจอร์นี้ กรุณาอัปเกรดแพ็กเกจก่อน!',
            communityWorksTitle: 'ผลงานเด่นจากชุมชน',
            communityWorksSubtitle: 'ผลงานสุดอัศจรรย์ที่สร้างโดยโมเดล AI',
            createSimilar: 'สร้างแบบคล้ายกัน',
            inspirationRecommend: 'แรงบันดาลใจที่แนะนำ',
            viewMoreWorks: 'ดูผลงานจากชุมชน 1000+ ชิ้น',
            textToVideo: 'ข้อความเป็นวิดีโอ',
            imageToVideo: 'รูปภาพเป็นวิดีโอ',
            imageToImage: 'รูปภาพเป็นรูปภาพ',
        },
    },
    // 丹麦语
    da: {
        common: {
            tip: 'Tip',
            pleaseInputPrompt: 'Indtast venligst prompt',
            pleaseInputImage: 'Upload venligst et billede',
            download: 'Download',
            cancel: 'Annuller',
            confirm: 'Bekræft',
            loading: 'Indlæser...',
            loadMore: 'Indlæs mere',
            noMore: 'Ikke mere',
            oneTaskRunning: 'Vent venligst mens der genereres',
            maxImageSize: 'Billedstørrelsen må ikke overstige {maxSize} MB',
            onlineSearch: 'Online søgning',
            searchFrom: 'Vil du aktivere Google-søgning?',
            operationFailed: 'Handling mislykkedes',
            loadFailed: 'Indlæsning mislykkedes',
            requestTimeout: 'Anmodning timeout, prøv igen senere',
            pageNotFoundTitle: 'AI er faret vild',
            pageNotFoundDesc:
                'Denne side blev muligvis overset under AI-modeltræning, eller den er stadig under generering... Tjek vores populære AI-modeller og udforsk flere kreative muligheder!',
            unexpectedErrorTitle: 'AI stødte på et problem',
            unexpectedErrorDesc:
                'Noget uventet skete under indlæsning. AI tænker måske, eller netværket har brug for en pause. Du kan vende tilbage til forsiden og prøve igen senere.',
            goHome: 'Gå til forsiden',
            goBack: 'Gå tilbage',
            errorTip: 'Hvis dette fortsætter, tag et screenshot og kontakt support.',
            errorDebug: 'Debug info (kun dev)',
            reupload: 'Upload igen',
            supportTypes: 'Understøtter JPG, PNG, WEBP formater',
            aiReversalTitle: 'AI Prompt Reverse',
            aiReversalShort: 'AI Reverse',
            use: 'Brug',
            startReversal: 'Start reverse',
            popularAIModels: 'Populære AI-modeller',
            previous: 'Forrige',
            next: 'Næste',
            videoCarousel: 'Video karrusel',
            goToSlide: 'Gå til slide {number}',
            analyzing: 'Analyserer...',
            loginToGetFree: 'Log ind for at skabe gratis',
            tryNow: 'Prøv nu',
            model_online: `{model} er nu live`,
            three_step: '3 nemme trin til at starte',
            close: 'Luk',
            copy: 'Kopier',
            like: 'Synes godt om',
            unlike: 'Synes ikke godt om',
            play: 'Afspil',
            pause: 'Pause',
            backward: 'Tilbage',
            forward: 'Frem',
            high_level_tip: 'Dette er en avanceret funktion. Opgrader din plan for at bruge den!',
            suggest_tip: 'Din nuværende plan understøtter ikke denne funktion. Opgrader venligst først!',
            communityWorksTitle: 'Fællesskabets fremhævede værker',
            communityWorksSubtitle: 'Fantastiske kreationer genereret af AI-modeller',
            createSimilar: 'Opret lignende',
            inspirationRecommend: 'Anbefalet inspiration',
            viewMoreWorks: 'Se 1000+ fællesskabsværker',
            textToVideo: 'Tekst til video',
            imageToVideo: 'Billede til video',
            imageToImage: 'Billede til billede',
        },
    },
    // 挪威语
    no: {
        common: {
            tip: 'Tips',
            pleaseInputPrompt: 'Vennligst skriv inn prompt',
            pleaseInputImage: 'Vennligst last opp et bilde',
            download: 'Last ned',
            cancel: 'Avbryt',
            confirm: 'Bekreft',
            loading: 'Laster...',
            loadMore: 'Last inn mer',
            noMore: 'Ikke mer',
            oneTaskRunning: 'Vennligst vent mens det genereres',
            maxImageSize: 'Bildestørrelsen kan ikke overstige {maxSize} MB',
            onlineSearch: 'Online søk',
            searchFrom: 'Vil du aktivere Google-søk?',
            operationFailed: 'Operasjon mislyktes',
            loadFailed: 'Lasting mislyktes',
            requestTimeout: 'Forespørsel tidsavbrudd, prøv igjen senere',
            pageNotFoundTitle: 'AI har gått seg vill',
            pageNotFoundDesc:
                'Denne siden ble kanskje oversett under AI-modelltrening, eller den er fortsatt under generering... Sjekk ut våre populære AI-modeller og utforsk flere kreative muligheter!',
            unexpectedErrorTitle: 'AI støtte på et problem',
            unexpectedErrorDesc:
                'Noe uventet skjedde under lasting. AI tenker kanskje, eller nettverket trenger en pause. Du kan gå tilbake til forsiden og prøve igjen senere.',
            goHome: 'Gå til forsiden',
            goBack: 'Gå tilbake',
            errorTip: 'Hvis dette fortsetter, ta et skjermbilde og kontakt support.',
            errorDebug: 'Debug info (kun dev)',
            reupload: 'Last opp på nytt',
            supportTypes: 'Støtter JPG, PNG, WEBP formater',
            aiReversalTitle: 'AI Prompt Reverse',
            aiReversalShort: 'AI Reverse',
            use: 'Bruk',
            startReversal: 'Start reverse',
            popularAIModels: 'Populære AI-modeller',
            previous: 'Forrige',
            next: 'Neste',
            videoCarousel: 'Video karusell',
            goToSlide: 'Gå til lysbilde {number}',
            analyzing: 'Analyserer...',
            loginToGetFree: 'Logg inn for å skape gratis',
            tryNow: 'Prøv nå',
            model_online: `{model} er nå live`,
            three_step: '3 enkle trinn for å starte',
            close: 'Lukk',
            copy: 'Kopier',
            like: 'Liker',
            unlike: 'Liker ikke',
            play: 'Spill av',
            pause: 'Pause',
            backward: 'Tilbake',
            forward: 'Fremover',
            high_level_tip: 'Dette er en avansert funksjon. Oppgrader planen din for å bruke den!',
            suggest_tip: 'Din nåværende plan støtter ikke denne funksjonen. Vennligst oppgrader først!',
            communityWorksTitle: 'Fremhevede fellesskapsverk',
            communityWorksSubtitle: 'Fantastiske kreasjoner generert av AI-modeller',
            createSimilar: 'Lag lignende',
            inspirationRecommend: 'Anbefalt inspirasjon',
            viewMoreWorks: 'Se 1000+ samfunnsverk',
            textToVideo: 'Tekst til video',
            imageToVideo: 'Bilde til video',
            imageToImage: 'Bilde til bilde',
        },
    },
    // 荷兰语
    nl: {
        common: {
            tip: 'Tip',
            pleaseInputPrompt: 'Voer een prompt in',
            pleaseInputImage: 'Upload een afbeelding',
            download: 'Downloaden',
            cancel: 'Annuleren',
            confirm: 'Bevestigen',
            loading: 'Laden...',
            loadMore: 'Meer laden',
            noMore: 'Niet meer',
            oneTaskRunning: 'Even geduld terwijl er wordt gegenereerd',
            maxImageSize: 'Afbeeldingsgrootte mag niet groter zijn dan {maxSize} MB',
            onlineSearch: 'Online zoeken',
            searchFrom: 'Wilt u Google-zoeken inschakelen?',
            operationFailed: 'Bewerking mislukt',
            loadFailed: 'Laden mislukt',
            requestTimeout: 'Verzoek timeout, probeer het later opnieuw',
            pageNotFoundTitle: 'AI is verdwaald',
            pageNotFoundDesc:
                'Deze pagina is mogelijk overgeslagen tijdens AI-modeltraining, of wordt nog gegenereerd... Bekijk onze populaire AI-modellen en ontdek meer creatieve mogelijkheden!',
            unexpectedErrorTitle: 'AI ondervond een probleem',
            unexpectedErrorDesc:
                'Er is iets onverwachts gebeurd tijdens het laden. De AI denkt misschien na, of het netwerk heeft een pauze nodig. U kunt teruggaan naar de startpagina en het later opnieuw proberen.',
            goHome: 'Ga naar home',
            goBack: 'Ga terug',
            errorTip: 'Als dit blijft gebeuren, maak een screenshot en neem contact op met support.',
            errorDebug: 'Debug info (alleen dev)',
            reupload: 'Opnieuw uploaden',
            supportTypes: 'Ondersteunt JPG, PNG, WEBP formaten',
            aiReversalTitle: 'AI Prompt Reverse',
            aiReversalShort: 'AI Reverse',
            use: 'Gebruiken',
            startReversal: 'Start reverse',
            popularAIModels: 'Populaire AI-modellen',
            previous: 'Vorige',
            next: 'Volgende',
            videoCarousel: 'Video carrousel',
            goToSlide: 'Ga naar dia {number}',
            analyzing: 'Analyseren...',
            loginToGetFree: 'Log in om gratis te creëren',
            tryNow: 'Probeer nu',
            model_online: `{model} is nu live`,
            three_step: '3 eenvoudige stappen om te beginnen',
            close: 'Sluiten',
            copy: 'Kopiëren',
            like: 'Vind ik leuk',
            unlike: 'Vind ik niet leuk',
            play: 'Afspelen',
            pause: 'Pauzeren',
            backward: 'Terug',
            forward: 'Vooruit',
            high_level_tip: 'Dit is een geavanceerde functie. Upgrade uw plan om het te gebruiken!',
            suggest_tip: 'Uw huidige plan ondersteunt deze functie niet. Upgrade eerst uw plan!',
            communityWorksTitle: 'Uitgelichte gemeenschapswerken',
            communityWorksSubtitle: 'Prachtige creaties gegenereerd door AI-modellen',
            createSimilar: 'Maak vergelijkbaar',
            inspirationRecommend: 'Aanbevolen inspiratie',
            viewMoreWorks: 'Bekijk 1000+ communitywerken',
            textToVideo: 'Tekst naar video',
            imageToVideo: 'Afbeelding naar video',
            imageToImage: 'Afbeelding naar afbeelding',
        },
    },
    // 印尼语
    id: {
        common: {
            tip: 'Tips',
            pleaseInputPrompt: 'Silakan masukkan prompt',
            pleaseInputImage: 'Silakan unggah gambar',
            download: 'Unduh',
            cancel: 'Batal',
            confirm: 'Konfirmasi',
            loading: 'Memuat...',
            loadMore: 'Muat lebih banyak',
            noMore: 'Tidak ada lagi',
            oneTaskRunning: 'Mohon tunggu sementara sedang dibuat',
            maxImageSize: 'Ukuran gambar tidak boleh melebihi {maxSize} MB',
            onlineSearch: 'Pencarian online',
            searchFrom: 'Apakah Anda ingin mengaktifkan pencarian Google?',
            operationFailed: 'Operasi gagal',
            loadFailed: 'Gagal memuat',
            requestTimeout: 'Waktu permintaan habis, silakan coba lagi nanti',
            pageNotFoundTitle: 'AI tersesat',
            pageNotFoundDesc:
                'Halaman ini mungkin terlewat selama pelatihan model AI, atau masih dalam proses pembuatan... Lihat model AI populer kami dan jelajahi lebih banyak kemungkinan kreatif!',
            unexpectedErrorTitle: 'AI mengalami masalah',
            unexpectedErrorDesc:
                'Terjadi kesalahan saat memuat. AI mungkin sedang berpikir, atau jaringan membutuhkan istirahat. Anda dapat kembali ke beranda dan mencoba lagi nanti.',
            goHome: 'Ke beranda',
            goBack: 'Kembali',
            errorTip: 'Jika ini terus terjadi, ambil tangkapan layar dan hubungi dukungan.',
            errorDebug: 'Info debug (hanya dev)',
            reupload: 'Unggah ulang',
            supportTypes: 'Mendukung format JPG, PNG, WEBP',
            aiReversalTitle: 'AI Prompt Reverse',
            aiReversalShort: 'AI Reverse',
            use: 'Gunakan',
            startReversal: 'Mulai reverse',
            popularAIModels: 'Model AI populer',
            previous: 'Sebelumnya',
            next: 'Selanjutnya',
            videoCarousel: 'Carousel video',
            goToSlide: 'Pergi ke slide {number}',
            analyzing: 'Menganalisis...',
            loginToGetFree: 'Masuk untuk membuat gratis',
            tryNow: 'Coba sekarang',
            model_online: `{model} sekarang live`,
            three_step: '3 langkah mudah untuk memulai',
            close: 'Tutup',
            copy: 'Salin',
            like: 'Suka',
            unlike: 'Tidak suka',
            play: 'Putar',
            pause: 'Jeda',
            backward: 'Mundur',
            forward: 'Maju',
            high_level_tip: 'Ini adalah fitur lanjutan. Upgrade paket Anda untuk menggunakannya!',
            suggest_tip: 'Paket Anda saat ini tidak mendukung fitur ini. Silakan upgrade paket Anda terlebih dahulu!',
            communityWorksTitle: 'Karya Unggulan Komunitas',
            communityWorksSubtitle: 'Kreasi menakjubkan yang dihasilkan oleh model AI',
            createSimilar: 'Buat Serupa',
            inspirationRecommend: 'Inspirasi yang Direkomendasikan',
            viewMoreWorks: 'Lihat 1000+ karya komunitas',
            textToVideo: 'Teks ke Video',
            imageToVideo: 'Gambar ke Video',
            imageToImage: 'Gambar ke Gambar',
        },
    },
    // 土耳其语
    tr: {
        common: {
            tip: 'İpucu',
            pleaseInputPrompt: 'Lütfen prompt girin',
            pleaseInputImage: 'Lütfen bir resim yükleyin',
            download: 'İndir',
            cancel: 'İptal',
            confirm: 'Onayla',
            loading: 'Yükleniyor...',
            loadMore: 'Daha fazla yükle',
            noMore: 'Daha fazla yok',
            oneTaskRunning: 'Lütfen oluşturulurken bekleyin',
            maxImageSize: 'Resim boyutu {maxSize} MB\'ı aşamaz',
            onlineSearch: 'Çevrimiçi arama',
            searchFrom: 'Google aramasını etkinleştirmek ister misiniz?',
            operationFailed: 'İşlem başarısız',
            loadFailed: 'Yükleme başarısız',
            requestTimeout: 'İstek zaman aşımı, lütfen daha sonra tekrar deneyin',
            pageNotFoundTitle: 'AI kayboldu',
            pageNotFoundDesc:
                'Bu sayfa AI model eğitimi sırasında atlanmış olabilir veya hala oluşturuluyor olabilir... Popüler AI modellerimize göz atın ve daha fazla yaratıcı olasılığı keşfedin!',
            unexpectedErrorTitle: 'AI bir sorunla karşılaştı',
            unexpectedErrorDesc:
                'Yüklenirken beklenmeyen bir şey oldu. AI düşünüyor olabilir veya ağın bir molaya ihtiyacı var. Ana sayfaya dönüp daha sonra tekrar deneyebilirsiniz.',
            goHome: 'Ana sayfaya git',
            goBack: 'Geri dön',
            errorTip: 'Bu devam ederse, ekran görüntüsü alın ve destek ile iletişime geçin.',
            errorDebug: 'Hata ayıklama bilgisi (sadece dev)',
            reupload: 'Tekrar yükle',
            supportTypes: 'JPG, PNG, WEBP formatlarını destekler',
            aiReversalTitle: 'AI Prompt Reverse',
            aiReversalShort: 'AI Reverse',
            use: 'Kullan',
            startReversal: 'Reverse başlat',
            popularAIModels: 'Popüler AI modelleri',
            previous: 'Önceki',
            next: 'Sonraki',
            videoCarousel: 'Video karusel',
            goToSlide: 'Slayt {number}\'e git',
            analyzing: 'Analiz ediliyor...',
            loginToGetFree: 'Ücretsiz oluşturmak için giriş yapın',
            tryNow: 'Şimdi dene',
            model_online: `{model} şimdi yayında`,
            three_step: 'Başlamak için 3 kolay adım',
            close: 'Kapat',
            copy: 'Kopyala',
            like: 'Beğen',
            unlike: 'Beğenme',
            play: 'Oynat',
            pause: 'Duraklat',
            backward: 'Geri',
            forward: 'İleri',
            high_level_tip: 'Bu gelişmiş bir özelliktir. Kullanmak için planınızı yükseltin!',
            suggest_tip: 'Mevcut planınız bu özelliği desteklemiyor. Lütfen önce planınızı yükseltin!',
            communityWorksTitle: 'Topluluk Öne Çıkan Çalışmalar',
            communityWorksSubtitle: 'AI modelleri tarafından oluşturulan muhteşem eserler',
            createSimilar: 'Benzer Oluştur',
            inspirationRecommend: 'Önerilen İlham',
            viewMoreWorks: '1000+ topluluk eserini görüntüle',
            textToVideo: 'Metinden videoya',
            imageToVideo: 'Görselten videoya',
            imageToImage: 'Görselten görsele',
        },
    },
}
